import React, { useEffect } from 'react'
import Breadcrumb from '../../../../../components/Breadcrum';
import InfoContainer from '../../../../../components/InfoContainer';
const peanutData = [
  {
    imgSrc: "./assets/img/agriculturalCommodities/groundnut-in-shell.jpg",
    text: "Groundnut in Shell",
    // certificateSrc: "./assets/img/certificates/pharmexcell-certificate.jpg",
  },

];
const BlanchedPeanuts = [
  {
    imgSrc: "./assets/img/agriculturalCommodities/whole-blanched.jpg",
    text: "Groundnut in Shell",
    // certificateSrc: "./assets/img/certificates/pharmexcell-certificate.jpg",
  },
  {
    imgSrc: "./assets/img/agriculturalCommodities/split-blanched-peanuts.jpg",
    text: "Split Blanched",
    // certificateSrc: "./assets/img/certificates/pharmexcell-certificate.jpg",
  },

];
const VarietiespeanutData = [
  {
    imgSrc: "./assets/img/agriculturalCommodities/peanut-bold.jpg",
    text: "Bold",
    // certificateSrc: "./assets/img/certificates/pharmexcell-certificate.jpg",
  },
  {
    imgSrc: "./assets/img/agriculturalCommodities/peanut-java.jpg",
    text: "Java",
    // certificateSrc: "./assets/img/certificates/pharmexcell-certificate.jpg",
  },
  {
    imgSrc: "./assets/img/agriculturalCommodities/peanut-red-skin.jpg",
    text: "Red Skin Java",
    // certificateSrc: "./assets/img/certificates/pharmexcell-certificate.jpg",
  },

];
export default function Peanuts () {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <>
      <Breadcrumb
        title="Peanut"
        backgroundImage='./assets/img/contact-banner.png'
        height="40vh"
      ></Breadcrumb>

      <div className="container pt-5">
        <div className="cashew-grades">
          <p>India is one of the largest producer of peanuts in the world. Indian peanuts are available in different varieties: Bolds or Runners, Javas or Spanish and Red Natals; and have a rich nutty flavour, sweet taste, crunchy texture and a relatively longer shelf life.
            Peanuts in India are available throughout the year due to a two-crop cycle harvested in March and October. On an average, India produces 7- 8 million tonnes of peanuts (unshelled) every year. In fact, considering the current export figures, India has a much larger potential to supply high quality groundnuts to the international buyer.
            The awareness and concern for quality amongst the Indian peanut shellers and processors are growing steadily. Multiple sorting and grading are fast becoming a norm. Indian shippers have the capability to prepare and supply edible peanuts conforming to highest standards.</p>
          <h4 className="mb-15px">Peanut in Shell</h4>
          <p>The Peanut consists of an external hull (or shell) (21-29%) surrounding the nut (79-71%). Peanut hulls, not to be confounded with peanut skins (which are the thin paper-like seed coats enclosing the kernel), are a by-product of peanut processing. The shelling of peanuts is often the second operation (after cleaning) of peanut processing, as both the production of peanut oil and the production of peanut snacks, peanut butter and other peanut-based foods require kernels without hulls (except the production of in-shell peanuts). Peanut hulls usually consist of fragmented hulls with variable amounts of whole or broken kernels.</p>
      
          <div className="table-responsive">
            <table className="table table-bordered table-hover">
              <thead>
                <tr>
                  <th>Varity</th>
                  <th>Grade</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>Groundnuts In-Shell</td>
                  <td>
                  20/24, 24/28
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <section className="section-padding">
        <div className="container">
          <div className="row">
            <div className="col-lg-10 col-12 text-center mx-auto">
              {/* <h2 className="mb-5">Credentials</h2> */}
              {/* <h2 className="mb-5">Our Accreditations</h2> */}
            </div>

            {peanutData.map((peanuts, index) => (
              <div
                key={index}
                className="col-lg-3 col-md-6 col-12 mb-4 mb-lg-0"
                style={{
                  cursor: peanuts.certificateSrc ? "pointer" : "default",
                }}
              >
                <div className="featured-block d-flex justify-content-center align-items-center">
                  <div className="d-block">
                    <img
                      src={peanuts.imgSrc}
                      className="featured-block-image img-fluid"
                      alt={peanuts.text}
                    />
                    <p
                      className={`featured-block-text ${
                        ["FSSAI", "Chemexcil"].includes(peanuts.text)
                          ? "extra-padding"
                          : ""
                      }`}
                    >
                      <strong>{peanuts.text}</strong>
                    </p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
        </div>
        <div className="cashew-grades">
           <h4 className="mb-15px">Varieties of Peanuts</h4>
          <p>The 2 major varieties of Peanuts produced in India are Bold (runners) and Java (Spanish). The Bold variety peanuts have typically reddish brown skin with oblong shape, while Java variety have pink skin with spherical in shape.
             Bold peanuts are the major oilseed of India. It accounts for around 25% of the total oilseed production of the country. Annual production of India Peanuts and Indian Peanuts oil are around 5-8mln and 1.5mln tons respectively.</p>
      
          <div className="table-responsive">
            <table className="table table-bordered table-hover">
              <thead>
                <tr>
                  <th>Varity</th>
                  <th>Grade</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>Groundnuts In-Shell</td>
                  <td>
                  35/40, 38/42, 40/45, 45/50, 45/55, 60/70, 70/80
                  </td>
                </tr>
                <tr>
                  <td>Java Kernel</td>
                  <td>
                  40/50, 45/55, 60/70, 70/80, 80/90, 100/120
                  </td>
                </tr>
                <tr>
                  <td>Red Skin Java Kernel</td>
                  <td>
                  70/80, 80/90
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <section className="section-padding">
        <div className="container">
          <div className="row">
            <div className="col-lg-10 col-12 text-center mx-auto">
              {/* <h2 className="mb-5">Credentials</h2> */}
              {/* <h2 className="mb-5">Our Accreditations</h2> */}
            </div>

            {VarietiespeanutData.map((varieties, index) => (
              <div
                key={index}
                className="col-lg-3 col-md-6 col-12 mb-4 mb-lg-0"
                style={{
                  cursor: varieties.certificateSrc ? "pointer" : "default",
                }}
              >
                <div className="featured-block d-flex justify-content-center align-items-center">
                  <div className="d-block">
                    <img
                      src={varieties.imgSrc}
                      className="featured-block-image img-fluid"
                      alt={varieties.text}
                    />
                    <p
                      className={`featured-block-text ${
                        ["FSSAI", "Chemexcil"].includes(varieties.text)
                          ? "extra-padding"
                          : ""
                      }`}
                    >
                      <strong>{varieties.text}</strong>
                    </p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
        </div>
        <div className="cashew-grades">
           <h4 className="mb-15px">Blanched Peanuts</h4>
          <p>Many nuts like almonds, peanuts or hazelnuts are grown in a shell. When the shell is removed there is still a skin on the outside of the nutmeat. Blanching is a process that removes the skin from the nut meat.
So how do you blanch a nut? The process itself is done by putting the nuts in very hot water for about a minute (blanching) then cooling them rapidly and rubbing off the skin.Well, neither… it just depend what you plan on doing, cooking or snacking on the nuts. Blanched nuts are used mostly for cooking and baking. If the nut is unblanched and the skin is still on, the skin will separate during cooking. Leaving your baked goodie, a husky mess.But, for snacking nothing beats an unblanched nut. The husk adds just a touch of flavor, and is packed full of nutrients.</p>      
          <div className="table-responsive">
            <table className="table table-bordered table-hover">
              <thead>
                <tr>
                  <th>Varity</th>
                  <th>Grade</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>Whole Blanched Peanuts</td>
                  <td>
                  38/42, 40/50, 50/60, etc
                  </td>
                </tr>
                <tr>
                  <td>Split Blanched Peanuts</td>
                  <td>
                  40/50, 50/60, 60/70, etc.
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <section className="section-padding">
        <div className="container">
          <div className="row">
            <div className="col-lg-10 col-12 text-center mx-auto">
              {/* <h2 className="mb-5">Credentials</h2> */}
              {/* <h2 className="mb-5">Our Accreditations</h2> */}
            </div>

            {BlanchedPeanuts.map((blenched, index) => (
              <div
                key={index}
                className="col-lg-3 col-md-6 col-12 mb-4 mb-lg-0"
                style={{
                  cursor: blenched.certificateSrc ? "pointer" : "default",
                }}
              >
                <div className="featured-block d-flex justify-content-center align-items-center">
                  <div className="d-block">
                    <img
                      src={blenched.imgSrc}
                      className="featured-block-image img-fluid"
                      alt={blenched.text}
                    />
                    <p
                      className={`featured-block-text ${
                        ["FSSAI", "Chemexcil"].includes(blenched.text)
                          ? "extra-padding"
                          : ""
                      }`}
                    >
                      <strong>{blenched.text}</strong>
                    </p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
        </div>
      </div>
      <div className="container py-5">
        <div className="common-packing">
          <h4 className="mb-15px">Common Packing For Container Shipment</h4>
          <div className="table-responsive">
            <table className="table table-bordered table-hover">
              <thead>
                <tr>
                  <th>Items</th>
                  <th>Packing</th>
                  <th>Quantity in Container</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>Peanut Kernels</td>
                  <td>25Kgs / 50Kgs In Jute / PP Bag</td>
                  <td>17MTs to 19MTs per 20'FCL
                  based on the Size of Kernels</td>
                </tr>
                <tr>
                  <td>Peanut In Shell</td>
                  <td>30Kgs in PP Bag</td>
                  <td>15MTs per 40'FCL</td>
                </tr>
                <tr>
                  <td>Blanched Peanut kernels</td>
                  <td>12.5KgsX2 per Cartons
                  25Kgs per PP Bag</td>
                  <td>16MTs per 20'FCL
                  18MTs per 20'FCL</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
            <div className="container">
      <div className="row ">
        <div className="white_box">
          <section id="specification">
            {/* <h4 className="mb-15px">Benefits of Peanut Consumption</h4> */}
            <div className="row">
              <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                <div className="wrapper">
                <div class="wrapper">
                     <h4 class="mb-10px">Benefits of Peanut Consumption</h4>
                     <p>Peanuts are rich in nutrients,providing over 30 essential nutrients &amp; phytonutrients. Peanuts are a good source of niacin, folate, fiber,magnesium,Vitamin E, Manganese &amp; phosphorous. They also are naturally free of trans-fats and sodium and contain about 25% protein.</p>
                     <p>Peanuts are processed in various forms as Peanut butter/Flavoured peanuts/Coated peanuts/ Peanut bars/Chocolate spreads, nut biscuits, crushed nuts used on cakes, buns, icecream and desserts.</p>
                     <p>Innovation on use of peanuts in processed foods continues due to its excellent nutritional values.</p>
                  </div>
                </div>
              </div>
              <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                <section id="nutrition_fact">
                  <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                    <div className="wrapper">
                      <h4>Nutrition Facts</h4>
                      <ul>
                        <li className="top">Serving Size: 100gm</li>
                        <li className="border_top_thick"></li>
                        <li className="small"><b>Amounts per servings</b></li>
                        <li>
                          <div className="byonethird left"><b>Calories</b> 567</div>
                          <div className="bytwothird right textleft">Calories from Fat 415</div>
                        </li>
                        <li className="border_top_thin"></li>
                        <li className="small textleft"><b>% Daily Values*</b></li>
                        <li>
                          <div className="desc"><b>Total Fat</b> 45 g</div>
                          <div className="percent"><b>75</b>%</div>
                        </li>
                        <li className="sub">
                          <div className="desc">Saturated fat 7 g</div>
                          <div className="percent"><b>35</b>%</div>
                        </li>
                        <li className="sub">
                          <div className="desc">Polyunsaturated fat 16 g</div>
                          <div className="percent">&nbsp;</div>
                        </li>
                        <li className="sub">
                          <div className="desc">Monounsaturated fat 24 g</div>
                          <div className="percent">&nbsp;</div>
                        </li>
                        <li>
                          <div className="desc"><b>Cholesterol</b> 0 mg</div>
                          <div className="percent"><b>0</b>%</div>
                        </li>
                        <li>
                          <div className="desc"><b>Sodium</b> 18 mg</div>
                          <div className="percent"><b>0</b>%</div>
                        </li>
                        <li>
                          <div className="desc"><b>Potassium</b> 705 mg</div>
                          <div className="percent"><b>20</b>%</div>
                        </li>
                        <li>
                          <div className="desc"><b>Total Carbohydrate</b> 16 g</div>
                          <div className="percent"><b>5</b>%</div>
                        </li>
                        <li className="sub">
                          <div className="desc">Dietary fiber 9 g</div>
                          <div className="percent"><b>36</b>%</div>
                        </li>
                        <li className="sub">
                          <div className="desc">Sugar 4 g</div>
                          <div className="percent">&nbsp;</div>
                        </li>
                        <li>
                          <div className="desc"><b>Protein</b> 26 g</div>
                          <div className="percent"><b>52</b>%</div>
                        </li>
                        <li className="border_top_thick"></li>
                        <li>
                          <div className="bytwo left">
                            <div className="desc">Vitamin A</div>
                            <div className="percent"><b>0</b>%</div>
                          </div>
                          <div className="bytwo right">
                            <div className="desc">Vitamin C</div>
                            <div className="percent"><b>0</b>%</div>
                          </div>
                        </li>
                        <li>
                          <div className="bytwo left">
                            <div className="desc">Calcium</div>
                            <div className="percent"><b>9</b>%</div>
                          </div>
                          <div className="bytwo right">
                            <div className="desc">Iron</div>
                            <div className="percent"><b>25</b>%</div>
                          </div>
                        </li>
                        <li>
                          <div className="bytwo left">
                            <div className="desc">Vitamin D</div>
                            <div className="percent"><b>0</b>%</div>
                          </div>
                          <div className="bytwo right">
                            <div className="desc">Vitamin B-6</div>
                            <div className="percent"><b>15</b>%</div>
                          </div>
                        </li>
                        <li>
                          <div className="bytwo left">
                            <div className="desc">Vitamin B-12</div>
                            <div className="percent"><b>0</b>%</div>
                          </div>
                          <div className="bytwo right">
                            <div className="desc">Magnesium</div>
                            <div className="percent"><b>42</b>%</div>
                          </div>
                        </li>
                        <li className="small">*Percent Daily Values are based on a 2,000 Calorie diet.</li>
                      </ul>
                    </div>
                  </div>
                </section>
              </div>
            </div>
          </section>
        </div>
      </div>
      </div>

      <div className="greenbox container my-5">
        <div className="theme_facts">
          <h1>Facts on Peanut Nuts</h1>
          <p className="white">
            The peanut, also known as the groundnut and the goober and taxonomically classified as Arachis hypogaea, is a legume crop grown mainly for its edible seeds. It is widely grown in the tropics and subtropics, being important to both small and large commercial producers. It is classified as both a grain legume and, because of its high oil content, an oil crop. World annual production of shelled peanuts was 42 million tonnes in 2014. Atypically among crop plants, peanut pods develop underground rather than aboveground. It is this characteristic that the botanist Linnaeus used to assign the specific name hypogaea, which means "under the earth."
          </p>
          <p className="white">
            As a legume, the peanut belongs to the botanical family Fabaceae; this is also known as Leguminosae, and commonly known as the bean, or pea, family. Like most other legumes, peanuts harbor symbiotic nitrogen-fixing bacteria in root nodules. This capacity to fix nitrogen means peanuts require less nitrogen-containing fertilizer and improve soil fertility, making them valuable in crop rotations.
          </p>
          <p className="white">
            Peanuts are similar in taste and nutritional profile to tree nuts such as walnuts and almonds, and are often served in similar ways in Western cuisines. The botanical definition of a "nut" is a fruit whose ovary wall becomes very hard at maturity. Using this criterion, the peanut is not a true nut, but rather a legume. However, for culinary purposes and in common English language usage, peanuts are usually referred to as nuts.
          </p>
        </div>
      </div>
    </>
  );
}
